import * as React from 'react';
import * as styles from './style.css';
import { IconClose12, UIText2 } from '@cian/ui-kit';
import classNames from 'clsx';
import { ActionButtonContainer } from '../../containers/ActionButton';

export const SoldoutNotification = ({
  text,
  isOpen,
  close,
  open,
}: {
  text: string;
  isOpen: boolean;
  close(): void;
  open(): void;
}) => {
  return (
    <div className={classNames(styles['container'], isOpen && styles['open'])}>
      <button onClick={close} className={styles['close']}>
        <IconClose12 color="gray20_100" />
      </button>
      <div className={styles['content']}>
        <UIText2 fontWeight="bold">{text}</UIText2>
        <UIText2>Успей купить!</UIText2>
      </div>

      <ActionButtonContainer secondary={true} dynamicCalltrackingPlaceType="soldoutNotification" />
    </div>
  );
};
